import styled from 'styled-components'
import { RegionContainer } from '../../styles/Utility.styles'
import { DEVICE } from '../../../util/constants'

export const StickyContainer = styled(RegionContainer)`
  position: sticky;
  top: 0;
  z-index: 10;
  background: white;
  border-bottom: ${props => (props.isSticky ? '2px solid #e5e7eb' : 'none')};
  padding: 12px 0;
  margin-bottom: 20px;

  @media ${DEVICE.tabletL} {
    padding: 8px 0;
  }
`

export const JumpLinksWrapper = styled.div`
  grid-column: 2 / 3;
  padding: 0 20px;
  line-height: 1.5;
  font-size: 1.4rem;
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  padding: 0;
  opacity: 1;
  transition: opacity 0.2s ease-in-out;

  @media ${DEVICE.tabletL} {
    font-size: 1.6rem;
  }
`

export const JumpLinksLabel = styled.span`
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  color: var(--content-background-dark-blue);
  white-space: nowrap;
  margin-right: 6px;

  @media ${DEVICE.tabletL} {
    margin-right: 8px;
    margin-bottom: 4px;
  }
`

export const JumpLinkItem = styled.span`
  font-family: 'Open Sans', sans-serif;
  color: var(--highlight-blue);
  cursor: pointer;
  padding: 2px 0;
  transition: color 0.2s ease;
  position: relative;
  display: inline;

  &:hover {
    color: var(--graphic-accent-purple-2);
    text-decoration: underline;
  }

  &:focus {
    outline: 2px solid var(--highlight-blue);
    outline-offset: 2px;
  }

  @media ${DEVICE.tabletL} {
    padding: 4px 0;
  }

  /* Active state styling */
  ${props =>
    props.isActive &&
    `
    color: var(--content-background-dark-blue);
    font-weight: 600;
    cursor: default;

    &:hover {
      color: var(--content-background-dark-blue);
      text-decoration: none;
      }
      `}
`

export const JumpLinkSeparator = styled.span`
  color: #9ca3af;
  margin-left: 6px;
  margin-right: 6px;
  font-weight: normal;
  text-decoration: none;

  @media ${DEVICE.tabletL} {
    margin-left: 8px;
    margin-right: 8px;
  }
`
